import { Checkbox, Form, Input, InputNumber, Modal, Select } from "antd";
import { useEffect, useState } from "react";
import PhoneInput from "react-phone-input-2";
import "react-phone-input-2/lib/style.css";
import { validateCelular } from "../../../components/Globais";
import { numberPadrao } from "../../../uteis/formatPhoneNumber";
import { useMessage } from "../../../uteis/mensagens/useMessage";
import { layout } from "../../ViewGerenciarPostagens/styles";
import { useAdicionarAssinatura } from "../hooks/useAdicionarAssinatura";
import { ContainerAssinatura, TitleAssinatura } from "../styles";

type AssinaturaFormData = {
  nome?: string;
  celular?: string;
  quantidadeCotas?: number;
  formaPagamento?: "PIX" | "BOLETO" | "CARTAO";
  enviarWhatsapp?: boolean;
};

export default function ModalAdicionar({
  isModalOpen,
  handleFechar,
  fetch,
}: any) {
  const [formAdicionarAssinatura] = Form.useForm();
  const [phone, setPhone] = useState("");
  const [errorDisplayed, setErrorDisplayed] = useState(false);

  const { showSuccess, showError, showWarning, contextHolder } = useMessage();

  const {
    isLoading: isLoadingAdicionar,
    error,
    cadastrar,
    resetError,
  } = useAdicionarAssinatura();

  const handlePhoneChange = (value: string) => {
    setPhone(value);

    const celular = numberPadrao(value);
    formAdicionarAssinatura.setFieldValue("celular", celular);
  };

  const handleCadastrar = async () => {
    try {
      const values = await formAdicionarAssinatura.validateFields();
      const celular = numberPadrao(phone || values.celular);
      const erroCelular = validateCelular(celular);

      if (erroCelular) {
        showError(erroCelular);
        return;
      }

      const resultado = await cadastrar({
        nome: values.nome,
        celular,
        quantidadeCotas: Number(values.quantidadeCotas),
        formaPagamento: values.formaPagamento,
        planoAssinatura: "ANUNCIO_PROPRIEDADE",
        enviarWhatsapp: values.enviarWhatsapp ? true : undefined,
      });

      if (!resultado) {
        return;
      }

      if (resultado.variant === "warning") {
        showWarning(resultado.message);
      } else {
        showSuccess(resultado.message);
      }

      await fetch();
      formAdicionarAssinatura.resetFields();
      setPhone("");
      handleFechar();
    } catch {
      return;
    }
  };

  useEffect(() => {
    if (error && !errorDisplayed) {
      showError(error);
      setErrorDisplayed(true);

      setTimeout(() => {
        setErrorDisplayed(false);
        resetError();
      }, 3000);
    }
  }, [
    showError,
    errorDisplayed,
    error,
    resetError,
  ]);

  useEffect(() => {
    if (isModalOpen) {
      resetError();
      setErrorDisplayed(false);
      formAdicionarAssinatura.resetFields();
      formAdicionarAssinatura.setFieldsValue({
        quantidadeCotas: 1,
        enviarWhatsapp: false,
      });
      setPhone("");
    }
  }, [isModalOpen, formAdicionarAssinatura, resetError]);

  return (
    <>
      {contextHolder}
      <Modal
        width={640}
        open={isModalOpen}
        onCancel={handleFechar}
        cancelText="Cancelar"
        okText="Cadastrar"
        onOk={handleCadastrar}
        confirmLoading={isLoadingAdicionar}
        okButtonProps={{
          style: {
            backgroundColor: "#003644",
            borderColor: "#003644",
            color: "white",
          },
        }}
        cancelButtonProps={{
          style: {
            backgroundColor: "#f44336",
            borderColor: "#f44336",
            color: "white",
          },
        }}
      >
        <ContainerAssinatura>
          <TitleAssinatura>Adicionar Assinatura</TitleAssinatura>

          <Form
            {...layout}
            form={formAdicionarAssinatura}
            name="assinatura"
            style={{ marginTop: "24px" }}
            initialValues={{
              quantidadeCotas: 1,
              enviarWhatsapp: false,
            }}
          >
            <Form.Item name="nome" label="Nome" className="formItems">
              <Input placeholder="Digite o nome" />
            </Form.Item>

            <Form.Item
              name="celular"
              label="Celular"
              className="formItems"
              rules={[{ required: true, message: "Informe o celular." }]}
            >
              <div style={{ width: "100%" }}>
                <PhoneInput
                  country={"br"}
                  value={phone}
                  onChange={handlePhoneChange}
                  enableSearch
                  placeholder="Digite o telefone"
                  inputStyle={{ width: "100%" }}
                  containerStyle={{ width: "100%" }}
                  dropdownStyle={{ zIndex: 2050 }}
                />
              </div>
            </Form.Item>

            <Form.Item
              name="quantidadeCotas"
              label="Quantidade de cotas"
              className="formItems"
              rules={[
                { required: true, message: "Informe a quantidade de cotas." },
              ]}
            >
              <InputNumber
                min={1}
                precision={0}
                style={{ width: "100%" }}
                placeholder="Informe a quantidade de cotas"
              />
            </Form.Item>

            <Form.Item
              name="formaPagamento"
              label="Forma de pagamento"
              className="formItems"
              extra="Se nao selecionar, o link sera gerado com o meio de pagamento em aberto."
            >
              <Select
                allowClear
                placeholder="Selecione a forma de pagamento"
                options={[
                  { value: "CARTAO", label: "Cartao" },
                  { value: "BOLETO", label: "Boleto" },
                  { value: "PIX", label: "PIX" },
                ]}
              />
            </Form.Item>

            <Form.Item
              name="enviarWhatsapp"
              valuePropName="checked"
              className="formItems"
            >
              <Checkbox>Enviar Msg?</Checkbox>
            </Form.Item>
          </Form>
        </ContainerAssinatura>
      </Modal>
    </>
  );
}
